const BRAND_RULES = [
  {
    hosts: ['quemimo.com', 'www.quemimo.com', 'quemimo.com.br', 'www.quemimo.com.br'],
    title: 'QueMimo',
    favicon: 'favicon.ico',
  },
]

const FALLBACK_BRAND = {
  title: 'QueMimo',
  favicon: 'favicon.ico',
}

function resolveCurrentBrand() {
  if (typeof window === 'undefined') {
    return {
      title: process.env.VUE_APP_BRAND_TITLE || FALLBACK_BRAND.title,
      favicon: process.env.VUE_APP_BRAND_FAVICON || FALLBACK_BRAND.favicon,
    }
  }

  const hostBrand = resolveBrandByHost(window.location.hostname)
  return {
    title: (process.env.VUE_APP_BRAND_TITLE || hostBrand.title || FALLBACK_BRAND.title).trim(),
    favicon: (process.env.VUE_APP_BRAND_FAVICON || hostBrand.favicon || FALLBACK_BRAND.favicon).trim(),
  }
}

function buildAssetUrl(path) {
  if (!path) {
    return ''
  }

  if (/^https?:\/\//i.test(path) || path.startsWith('/')) {
    return path
  }

  const base = process.env.BASE_URL || '/'
  return `${base}${path}`
}

function resolveBrandByHost(hostname) {
  const host = (hostname || '').toLowerCase().trim()
  const matched = BRAND_RULES.find((rule) => rule.hosts.includes(host))
  return matched || FALLBACK_BRAND
}

function setFavicon(iconHref) {
  if (!iconHref || typeof document === 'undefined') {
    return
  }

  const links = document.querySelectorAll('link[rel*="icon"]')
  if (!links.length) {
    const link = document.createElement('link')
    link.rel = 'icon'
    link.href = iconHref
    document.head.appendChild(link)
    return
  }

  links.forEach((link) => {
    link.href = iconHref
  })
}

export function applyBranding() {
  if (typeof window === 'undefined' || typeof document === 'undefined') {
    return
  }

  const brand = resolveCurrentBrand()
  const title = brand.title
  const faviconPath = brand.favicon
  const faviconUrl = buildAssetUrl(faviconPath)

  document.title = title
  setFavicon(faviconUrl)
}

export function getBrandTitle() {
  return resolveCurrentBrand().title
}

export function formatPageTitle(pageTitle) {
  const brandTitle = getBrandTitle()
  const page = String(pageTitle || '').trim()

  if (!page) {
    return brandTitle
  }

  return `${brandTitle} | ${page}`
}
